import AvailableCurrencyTable from './available-currency-table';

export default AvailableCurrencyTable;